// Смена «переезжает» в 06:00 по Москве — совпадает с сервером
// (finance/views.py: BUSINESS_DAY_OFFSET_HOURS). До 6 утра «сегодня» = ещё вчера.
export const BUSINESS_DAY_OFFSET_HOURS = 6;

// Деловой день в формате YYYY-MM-DD:
// берём московскую календарную дату момента «сейчас минус 6 часов».
export function businessTodayISO() {
    const shifted = new Date(Date.now() - BUSINESS_DAY_OFFSET_HOURS * 3600 * 1000);
    return shifted.toLocaleDateString('en-CA', { timeZone: 'Europe/Moscow' }); // YYYY-MM-DD
}

// Тот же деловой день как локальный Date на полночь —
// удобно для арифметики недели/месяца.
export function businessToday() {
    const [y, m, d] = businessTodayISO().split('-').map(Number);
    return new Date(y, m - 1, d);
}


// Деловой день со сдвигом на N дней (0 = сегодня, -1 = вчера) в формате YYYY-MM-DD.
export function businessDayISO(offsetDays = 0) {
    const base = businessToday();               // локальная полночь делового «сегодня»
    base.setDate(base.getDate() + offsetDays);
    const y = base.getFullYear();
    const m = String(base.getMonth() + 1).padStart(2, '0');
    const d = String(base.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}